import { useMemo } from 'react';
import { SubscriptionCategory } from '../../../../common/enums';
import { useSelfServiceData } from '../../../../common/hooks/useSelfServiceData';
import { SelfServiceHome } from '../../../../components/SelfServiceHome/SelfServiceHome.js';

export const SelfServiceHomePath = () => {
  const {
    subscriptions,
    loading,
    allInvoices,
    billingAccounts,
    openInvoices,
    customerOrders,
    pendingRedeemRequests,
    supportCases,
    summaryLoading,
  } = useSelfServiceData();

  const { VOICE, DEVICE, BROADBAND, SERVICE } = SubscriptionCategory;
  const voice = subscriptions[VOICE];
  const device = subscriptions[DEVICE];
  const broadband = subscriptions[BROADBAND];
  const service = subscriptions[SERVICE];

  const serviceCounts = useMemo(
    () => ({
      mobile: voice.filter(s => s.subscriptionType === 'MOBILE').length,
      landline: voice.filter(s => s.subscriptionType === 'LANDLINE').length,
      devices: device.length,
      broadband: broadband.filter(s =>
        ['BROADBAND', 'CORPORATE_NETWORK', 'HOUSING_COMPANY_BROADBAND'].includes(s.subscriptionType ?? '')
      ).length,
      mobileBroadband: broadband.filter(s => ['MOBILE_BROADBAND', 'MOBILE_M2M'].includes(s.subscriptionType ?? ''))
        .length,
      services: service.length,
    }),
    [voice, device, broadband, service]
  );

  const serviceLoading = {
    mobile: loading[VOICE],
    landline: loading[VOICE],
    devices: loading[DEVICE],
    broadband: loading[BROADBAND],
    mobileBroadband: loading[BROADBAND],
    services: loading[SERVICE],
  };

  return (
    <SelfServiceHome
      voiceSubscriptions={voice}
      allInvoices={allInvoices}
      billingAccounts={billingAccounts}
      openInvoices={openInvoices}
      customerOrders={customerOrders}
      pendingRedeemRequest={pendingRedeemRequests}
      supportCases={supportCases}
      serviceCounts={serviceCounts}
      serviceLoading={serviceLoading}
      summaryLoading={summaryLoading}
    />
  );
};
